// extracted by mini-css-extract-plugin
module.exports = {"wrap":"HeadIcon_wrap__1SHGW","icon":"HeadIcon_icon__21q8O"};